import React from "react";
import AppRoutes from "./AppRoutes";

function App() {
  return (
    <div className="App">
      <div className="blue-sphere"></div>
      <div className="green-sphere"></div>
      <div className="yellow-sphere"></div>
      <div className="red-sphere"></div>
      <div className="green-sphere-2"></div>
      <AppRoutes />
    </div>
  );
}

export default App;
